import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import Button from '@sdk/components/ui/buttons/Button';

export const BannerContainer = styled(Row)`
  background: ${({ theme }) => theme.colors.columnHeaders};
  padding: 30px 40px;
  border-radius: 4px;
`;

export const BannerTextColumn = styled(Column)`
  flex: 2;
  margin-right: 40px;
`;

export const BannerButton = styled(Button)`
  max-width: 180px;
`;
